// Central content for TechSpace Solutions Ltd

export const COMPANY = {
  name: "TechSpace Solutions",
  legal: "TechSpace Solutions Ltd",
  tagline: "Building Intelligent Software That Transforms Businesses",
  altTagline: "AI-Powered Business Solutions for Healthcare, Retail and Enterprise",
  country: "United Kingdom",
  phone: "+44 20 4571 8890",
  email: "hello@techspacesolutions.co.uk",
  linkedin: "https://www.linkedin.com/company/techspace-solutions",
  address: "1 Canada Square, Canary Wharf, London, E14 5AB, United Kingdom",
};

export const DASHBOARDS = {
  ayobell:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_enterprise-ai-hub-80/artifacts/9y8rvvbi_image.png",
  smartpos:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_enterprise-ai-hub-80/artifacts/duf1bdu8_Screenshot%202026-07-30%20141358.jpg",
  founder: "https://customer-assets-cm19k8pv.emergentagent.net/job_enterprise-ai-hub-80/artifacts/ha8u2cy1_daps5bellos5.JPG",
};

export const SOLUTIONS = [
  {
    id: "ayobell",
    name: "AYOBELL",
    subtitle: "AI-Powered Care Management Platform",
    description:
      "AYOBELL is an enterprise care management platform built for Supported Living, Residential Care, Domiciliary Care and Healthcare Providers.",
    image: DASHBOARDS.ayobell,
    accent: "teal",
    features: [
      "Electronic Care Planning",
      "Medication Management (eMAR)",
      "Risk Assessments",
      "Daily Notes",
      "Appointments",
      "Incident Management",
      "Staff Rotas",
      "Audits",
      "Training Compliance",
      "Family Portal",
      "Executive Dashboard",
      "AI Care Assistant",
      "CQC Readiness Dashboard",
      "Evidence Pack Generator",
      "Voice Notes",
      "AI Manager Briefing",
    ],
  },
  {
    id: "smartposlite",
    name: "SmartPosLite",
    subtitle: "Next Generation Point of Sale Platform",
    description:
      "SmartPosLite helps retailers manage sales, inventory, customers and reporting from one intelligent platform.",
    image: DASHBOARDS.smartpos,
    accent: "navy",
    features: [
      "POS",
      "Inventory",
      "Barcode",
      "Customer Management",
      "Offline Mode",
      "Sales Reports",
      "Multi Store",
      "Paystack Integration",
      "Flutterwave Ready",
      "Supplier Management",
      "Analytics",
      "Cloud Sync",
    ],
  },
  {
    id: "housespend",
    name: "AYOBELL HouseSpend",
    subtitle: "Smart Household Expense & Budget Management",
    description:
      "AYOBELL HouseSpend is a secure multi-site expense and budget management platform designed for Care Homes, Supported Living, Residential Children's Homes and other care providers. It gives managers real-time visibility of household spending, budgets and receipts across every location.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_enterprise-ai-hub-80/artifacts/ox60dw11_image.png",
    gallery: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_enterprise-ai-hub-80/artifacts/ox60dw11_image.png",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_enterprise-ai-hub-80/artifacts/1eivkaxy_image.png",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_enterprise-ai-hub-80/artifacts/l0iprctc_image.png",
    ],
    accent: "teal",
    features: [
      "Weekly Household Budgets",
      "Multi-Site Expense Tracking",
      "Digital Receipt Management",
      "Staff Expense Submissions",
      "Expense Approval Workflow",
      "Real-Time Remaining Balances",
      "Merchant & Spending Categories",
      "Purchase Location Tracking",
      "Missing Receipt Alerts",
      "Weekly Reconciliation",
      "Management Dashboard",
      "PDF & Excel Reports",
      "Complete Audit Trail",
      "Role-Based Access",
    ],
  },
];

export const WHY_CHOOSE = [
  { title: "Enterprise Architecture", icon: "Building2", desc: "Robust, standards-driven systems designed for scale, resilience and long-term maintainability." },
  { title: "Artificial Intelligence", icon: "BrainCircuit", desc: "AI assistants, predictive insight and automation woven into every workflow." },
  { title: "Cloud Native", icon: "Cloud", desc: "Built for Azure — elastic, always-on and globally available by default." },
  { title: "Secure by Design", icon: "ShieldCheck", desc: "Security and compliance engineered in from the first line of code." },
  { title: "Mobile First", icon: "Smartphone", desc: "Beautiful, responsive experiences that work anywhere your teams do." },
  { title: "Scalable Platforms", icon: "Network", desc: "From a single site to national rollouts across the UK and Nigeria." },
];

export const INDUSTRIES = [
  { name: "Healthcare", icon: "HeartPulse" },
  { name: "Retail", icon: "ShoppingBag" },
  { name: "Supported Living", icon: "HousePlus" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Finance", icon: "Landmark" },
  { name: "Distribution", icon: "Truck" },
  { name: "Education", icon: "GraduationCap" },
  { name: "Government", icon: "Scale" },
];

export const SERVICES = [
  "AI Software Development",
  "Enterprise Architecture",
  "Cloud Migration",
  "Digital Transformation",
  "Microsoft Dynamics 365 Consulting",
  "System Integration",
  "Azure Cloud Solutions",
  "Business Intelligence",
  "Technical Architecture",
  "Release Management",
  "Environment Management",
];

export const BENEFITS = [
  { title: "Reduce Costs", icon: "TrendingDown" },
  { title: "Improve Compliance", icon: "ClipboardCheck" },
  { title: "Increase Productivity", icon: "Gauge" },
  { title: "Improve Customer Experience", icon: "Sparkles" },
  { title: "Better Reporting", icon: "BarChart3" },
  { title: "Cloud Ready", icon: "CloudCog" },
  { title: "Artificial Intelligence", icon: "Bot" },
];

export const TRUST = [
  "25+ years in IT",
  "14+ years of Microsoft Dynamics 365 expertise",
  "Enterprise solution architecture",
  "AI-powered software development",
  "Cloud-native platforms",
  "Healthcare technology innovation",
  "Retail technology solutions",
];

export const STATS = [
  { value: 25, suffix: "+", label: "Years in IT" },
  { value: 14, suffix: "+", label: "Years Dynamics 365" },
  { value: 3, suffix: "", label: "Flagship Products" },
  { value: 8, suffix: "", label: "Industries Served" },
];

export const FOUNDER = {
  name: "Daps Bellos",
  role: "Founder & Principal Solution Architect",
  summary:
    "Highly experienced Microsoft Dynamics 365 Solution Architect and Technical Consultant with over 25 years of IT experience and more than 14 years specialising in Microsoft Dynamics AX and Dynamics 365 Finance & Operations.",
  expertise: [
    "Solution Architecture",
    "Enterprise Integration",
    "Azure",
    "Release Management",
    "Environment Strategy",
    "Power Platform",
    "Cloud Technologies",
    "AI Solutions",
    "Healthcare Technology",
    "Digital Transformation",
    "Microsoft Technologies",
  ],
  certifications: ["Microsoft Certified", "Azure", "Dynamics 365", "ITIL", "Power Platform"],
  timeline: [
    { year: "2000", title: "Started IT Career", desc: "Began a long journey across enterprise IT and consulting." },
    { year: "2011", title: "Microsoft Dynamics AX", desc: "Specialised in Dynamics AX finance & operations delivery." },
    { year: "2016", title: "Dynamics 365 Solution Architect", desc: "Leading complex D365 F&O implementations and integrations." },
    { year: "2019", title: "Azure & Power Platform", desc: "Expanded into cloud architecture, DevOps and low-code automation." },
    { year: "2022", title: "AI & Digital Transformation", desc: "Delivering AI-driven platforms for healthcare and retail." },
    { year: "2024", title: "Founded TechSpace Solutions", desc: "Launched AYOBELL and SmartPosLite for the UK and Nigeria." },
  ],
};

export const NAV = [
  { label: "Solutions", href: "#solutions" },
  { label: "Why Us", href: "#why" },
  { label: "About", href: "#about" },
  { label: "Industries", href: "#industries" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];
